export const sendFunds = async (recieverAddy, amount) => {
  try {
    const tronweb = window.tronWeb;
    const amt = await tronweb.toSun(amount);
    const sendF = await tronweb.trx.sendTransaction(recieverAddy, amt);
    console.log(amount);
    // get gas price

    let hash = sendF;
    return { hash };
  } catch (error) {}
};
export const disconnect = async () => {
  await window.tronWeb.trx.setAddress("");
  console.log("okayy");
};
// get transaction start date, next pay day and compare if its due
export const getDueDate = async (companyAddy, payId) => {
  // calls the subcription method
  const tronweb = window.tronWeb;
  const contract = await tronweb
    .contract()
    .at(process.env.REACT_APP_companyAddress);
  const { nextPayment, start } = await contract
    .subscriptions(companyAddy, payId)
    .call();

  // convert the time from block.timestamp to normal time
  const startDate = new Date(start * 1000);
  const dueDate = new Date(nextPayment * 1000);

  // get current time
  const currentDate = new Date();

  if (dueDate.getTime() > currentDate.getTime()) {
    let due = false;
    return { startDate, dueDate, currentDate, due };
  } else {
    let due = true;
    return { startDate, dueDate, currentDate, due };
  }
};

// get paytron balance
export const getPaytronBalance = async (address) => {
  const contract = await window.tronWeb
    .contract()
    .at(process.env.REACT_APP_companyAddress);
  const balance = await contract.balances(address).call();
  return balance;
};
